import React from 'react'
import { Button, Form, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup';
import ErrorMessage from 'Components/ErrorMessage'
import { bindRef } from 'Utilities/formRef'
import { currentMonthCivilRange } from 'Utilities/dateTime'


const validationSchema = yup.object().shape({
    dateFrom: yup.string().required(),
    dateTo: yup.string().required(),
});

const Filter = inject("txtStore")(observer(({ txtStore: store }) => {
    const { from: defaultDateFrom, to: defaultDateTo } = currentMonthCivilRange()

    const { t } = useTranslation()

    const { register, handleSubmit, errors } = useForm({ validationSchema: validationSchema })

    function onSubmit(data) {
        store.fetchTxts(data.dateFrom, data.dateTo)
    }

    return (<Form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={store.isFetching}>
            <Form.Row>
                <Col xs={12} md={4}>
                    <Form.Group controlId="date_from">
                        <Form.Label>{t('date_from')}</Form.Label>
                        <Form.Control type="date"
                            name="dateFrom"
                            defaultValue={defaultDateFrom}
                            ref={bindRef(register)}
                        />
                        <ErrorMessage error={errors?.dateFrom} />
                    </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                    <Form.Group controlId="date_to">
                        <Form.Label>{t('date_to')}</Form.Label>
                        <Form.Control type="date"
                            name="dateTo"
                            defaultValue={defaultDateTo}
                            ref={bindRef(register)}
                        />
                        <ErrorMessage error={errors?.dateTo} />
                    </Form.Group>
                </Col>
                <Col xs={12} md={4} className="d-flex align-items-end">
                    <Form.Group className="w-100">
                        <Button className="w-100" type="submit">{t('search')}</Button>
                    </Form.Group>
                </Col>
            </Form.Row>
        </fieldset>
    </Form>)
}))

export default Filter